import { render, staticRenderFns } from "./drawing-previews.component.vue?vue&type=template&id=aa8abcae&scoped=true&"
import script from "./drawing-previews.component.ts?vue&type=script&lang=ts&"
export * from "./drawing-previews.component.ts?vue&type=script&lang=ts&"
import style0 from "./drawing-previews.component.scss?vue&type=style&index=0&id=aa8abcae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8abcae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})
